/**
 * @typedef {import('../MapLibreMap.js').MLD} MLD
 */

/**
 * @extends string
 * @typedef {"AF" | "AN" | "AS" | "EU" | "NA" | "OC" | "SA"} CountinentCode
 */

/**
 * @extends string
 * @typedef {"AD" | "AE" | "AF" | "AG" | "AI" | "AL" | "AM" | "AO" | "AQ" | "AR" | "AS" | "AT" | "AU" | "AW" | "AX" | "AZ" | "BA" | "BB" | "BD" | "BE" | "BF" | "BG" | "BH" | "BI" | "BJ" | "BL" | "BM" | "BN" | "BO" | "BQ" | "BR" | "BS" | "BT" | "BV" | "BW" | "BY" | "BZ" | "CA" | "CC" | "CD" | "CF" | "CG" | "CH" | "CI" | "CK" | "CL" | "CM" | "CN" | "CO" | "CR" | "CU" | "CV" | "CW" | "CX" | "CY" | "CZ" | "DE" | "DJ" | "DK" | "DM" | "DO" | "DZ" | "EC" | "EE" | "EG" | "EH" | "ER" | "ES" | "ET" | "FI" | "FJ" | "FK" | "FM" | "FO" | "FR" | "GA" | "GB" | "GD" | "GE" | "GF" | "GG" | "GH" | "GI" | "GL" | "GM" | "GN" | "GP" | "GQ" | "GR" | "GS" | "GT" | "GU" | "GW" | "GY" | "HK" | "HM" | "HN" | "HR" | "HT" | "HU" | "ID" | "IE" | "IL" | "IM" | "IN" | "IO" | "IQ" | "IR" | "IS" | "IT" | "JE" | "JM" | "JO" | "JP" | "KE" | "KG" | "KH" | "KI" | "KM" | "KN" | "KP" | "KR" | "KW" | "KY" | "KZ" | "LA" | "LB" | "LC" | "LI" | "LK" | "LR" | "LS" | "LT" | "LU" | "LV" | "LY" | "MA" | "MC" | "MD" | "ME" | "MF" | "MG" | "MH" | "MK" | "ML" | "MM" | "MN" | "MO" | "MP" | "MQ" | "MR" | "MS" | "MT" | "MU" | "MV" | "MW" | "MX" | "MY" | "MZ" | "NA" | "NC" | "NE" | "NF" | "NG" | "NI" | "NL" | "NO" | "NP" | "NR" | "NU" | "NZ" | "OM" | "PA" | "PE" | "PF" | "PG" | "PH" | "PK" | "PL" | "PM" | "PN" | "PR" | "PS" | "PT" | "PW" | "PY" | "QA" | "RE" | "RO" | "RS" | "RU" | "RW" | "SA" | "SB" | "SC" | "SD" | "SE" | "SG" | "SH" | "SI" | "SJ" | "SK" | "SL" | "SM" | "SN" | "SO" | "SR" | "SS" | "ST" | "SV" | "SX" | "SY" | "SZ" | "TC" | "TD" | "TF" | "TG" | "TH" | "TJ" | "TK" | "TL" | "TM" | "TN" | "TO" | "TR" | "TT" | "TV" | "TW" | "TZ" | "UA" | "UG" | "UM" | "US" | "UY" | "UZ" | "VA" | "VC" | "VE" | "VG" | "VI" | "VN" | "VU" | "WF" | "WS" | "YE" | "YT" | "ZA" | "ZM" | "ZW"} CountryCode
 */


/**
 * @typedef {Object} ICountryLocation
 * @property {number} north
 * @property {number} south
 * @property {number} east
 * @property {number} west
 */

/**
 * @typedef {Object.<string, ICountryLocation>} ICountryLocations
 */

window.OSM = window.OSM ?? {};


/**
 * @type {ICountryLocations}
 */
OSM.CountryLocations = {
    // Antarctica
    AQ: {
        north: -60,
        south: -85.0511287,
        east: 180,
        west: -180
    },
    // American Samoa
    AS: {
        north: -14.091293,
        south: -14.40808,
        east: -169.28833,
        west: -170.867615
    },
    // Aruba
    AW: {
        north: 12.649718,
        south: 12.385611,
        east: -69.852447509766,
        west: -70.073547363281
    },
    // Åland Islands
    AX: {
        north: 60.646262,
        south: 59.839295,
        east: 21.145935,
        west: 19.281006
    },
    // Saint Barthélemy
    BL: {
        north: 17.96860948572,
        south: 17.864727393843,
        east: -62.781715393066,
        west: -62.92350769043
    },
    // Bonaire, Sint Eustatius and Saba
    BQ: {
        north: 20.40642047492,
        south: 7.1226962775183,
        east: -57.4365234375,
        west: -78.0029296875
    },
    // Bouvet Island
    BV: {
        north: -54.384456223629,
        south: -54.456767735525,
        east: 3.4371757507324,
        west: 3.2816505432129
    },
    // Cocos (Keeling) Islands
    CC: {
        north: -11.802834,
        south: -12.232654837013,
        east: 96.948852539062,
        west: 96.788864135742
    },
    // Curaçao
    CW: {
        north: 12.421824385627,
        south: 11.943944636889,
        east: -68.608245849609,
        west: -69.187774658203
    },
    // Christmas Island
    CX: {
        north: -10.402728275524,
        south: -10.58535912707,
        east: 105.72040557861,
        west: 105.51853179932
    },
    // Fiji
    FJ: {
        north: -15.792253570362,
        south: -19.362976133342,
        east: -178.42895507812,
        west: 176.8798828125
    },
    // France
    FR: {
        north: 51.303145,
        south: 42.147114,
        east: 8.5693359375,
        west: -5.361328125
    },
    // French Guiana
    GF: {
        north: 6.0094592380596,
        south: 1.8234225930142,
        east: -51.30615234375,
        west: -54.810791015625
    },
    // Guadeloupe
    GP: {
        north: 16.525632239869,
        south: 15.79357502192,
        east: -60.971374511719,
        west: -61.857147216797
    },
    // Guam
    GU: {
        north: 13.690022049868,
        south: 13.214545199617,
        east: 144.9934387207,
        west: 144.59106445313
    },
    // Hong Kong
    HK: {
        north: 22.598797546833,
        south: 22.12635475992,
        east: 114.43359375,
        west: 113.77990722656
    },
    // Heard Island and McDonald Islands
    HM: {
        north: -52.943672899916,
        south: -53.220013075461,
        east: 73.903656005859,
        west: 72.567444
    },
    // Kiribati
    KI: {
        north: 2.0677272919038,
        south: 1.6669400831931,
        east: -157.14019775391,
        west: -157.57965087891
    },
    // Saint Martin (French part)
    MF: {
        north: 18.132801356085,
        south: 18.027710100219,
        east: -62.962646484375,
        west: -63.15731048584
    },
    // Macao
    MO: {
        north: 22.218237997802,
        south: 22.108384,
        east: 113.58661651611,
        west: 113.52670669556
    },
    // Northern Mariana Islands
    MP: {
        north: 19.134789188333,
        south: 13.891411092746,
        east: 146.32690429688,
        west: 144.85473632813
    },
    // Martinique
    MQ: {
        north: 14.902321826142,
        south: 14.372164289681,
        east: -60.780487060547,
        west: -61.240539550781
    },
    // New Caledonia
    NC: {
        north: -19.28003579628,
        south: -22.907803451058,
        east: 168.43139648438,
        west: 163.76220703125
    },
    // Norfolk Island
    NF: {
        north: -28.990724210337,
        south: -29.138667878318,
        east: 168.0029296875,
        west: 167.90817260742
    },
    // Netherlands
    NL: {
        north: 53.625095488698,
        south: 50.590211939352,
        east: 7.49267578125,
        west: 3.09814453125
    },
    // Norway
    NO: {
        north: 71.416678,
        south: 57.903174,
        east: 31.256104,
        west: 4.328613
    },
    // New Zealand
    NZ: {
        north: -33.431441,
        south: -52.829321,
        east: -175.36376953125,
        west: 164.64111328125
    },
    // French Polynesia
    PF: {
        north: -15.712950725807,
        south: -18.020527657852,
        east: -146.25549316406,
        west: -151.86950683594
    },
    // Saint Pierre and Miquelon
    PM: {
        north: 47.167309701316,
        south: 46.736095937701,
        east: -56.103057861328,
        west: -56.443634033203
    },
    // Réunion
    RE: {
        north: -20.843411564986,
        south: -21.419833053493,
        east: 55.861358642578,
        west: 55.159606933594
    },
    // Russian Federation
    RU: {
        north: 78.007325,
        south: 40.313043208881,
        east: -167.87109375,
        west: 26.54296875
    },
    // Saint Helena
    SH: {
        north: -15.895961,
        south: -16.037235,
        east: -5.62088,
        west: -5.793571
    },
    // Svalbard and Jan Mayen
    SJ: {
        north: 80.872827215057,
        south: 76.320753876849,
        east: 34.03564453125,
        west: 9.5361328125
    },
    // Sint Maarten (Dutch part)
    SX: {
        north: 18.068187474118,
        south: 18.000284653752,
        east: -63.005218505859,
        west: -63.131561279297
    },
    // French Southern Territories
    TF: {
        north: -46.042735653847,
        south: -50.205033264943,
        east: 71.3232421875,
        west: 51.39404296875
    },
    // Tuvalu
    TV: {
        north: -8.4156589061976,
        south: -8.6523052107278,
        east: 179.21413421631,
        west: 179.04075622559
    },
    // United States Minor Outlying Islands
    UM: {
        north: 60.586967342259,
        south: 4.2149431413906,
        east: -129.375,
        west: 156.62109375
    },
    // United States Minor Outlying Islands
    US: {
        north: 53.272086129794,
        south: 26.295374670206,
        east: -69.6402179375,
        west: -131.2515460625
    },
    // Virgin Islands, U.S.
    VI: {
        north: 18.464984,
        south: 17.623468,
        east: -64.512674,
        west: -65.159094
    },
    // Wallis and Futuna
    WF: {
        north: -13.173096930514,
        south: -14.432020320225,
        east: -176.0888671875,
        west: -178.25592041016
    },
    // Mayotte
    YT: {
        north: -12.609516300263,
        south: -13.027303876237,
        east: 45.308990478516,
        west: 44.994506835938
    }
}